"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _ThemeHelper = require("../Utilities/ThemeHelper");

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    root: {
      color: "inherit"
    },
    circular: {
      display: "flex"
    },
    inner: {
      margin: "0 auto"
    },
    verticallyCenter: {
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      flexGrow: 1
    }
  };
});
exports.useStyles = useStyles;